import React, { useEffect, useState } from 'react';
import { Button, TextField, Typography, Grid, Alert, Box, AppBar, IconButton, Toolbar, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { setAlert, setError } from '../../components/alert-message/alerMessageSlice';
import axios from 'axios';
import LogoIcon from '../../components/logoIcon/LogoIcon';
import { APP_NAME } from '../../variables';
import { clearLoadingMessage, setLoadingMessage } from '../../components/loading-dialog/loadingMessageSlice';
import { ArrowBack } from '@mui/icons-material';
import { Visibility, VisibilityOff } from '@mui/icons-material';


const UserChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [formValues, setFormValues] = useState({ 
    username: "", 
    old_password: "",
    new_password: "", 
    confirm_password: "",  
});

  const handleNextClick = async () => {
    const updateUrl = `${process.env.REACT_APP_API}/${process.env.REACT_APP_UPDATE_PASSWORD_ROUTE}/`
    const access_token = JSON.parse(localStorage.getItem('userData'))['access_token']

    dispatch(setLoadingMessage("Updating password..."))
    
    await axios.post(
        updateUrl, 
        formValues, 
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`
          },
          withCredentials: true
        }).then(response => {
            dispatch(setAlert({severity: "success", message: response?.data?.message}));
            navigate("/login");
            
        }).catch(err => {
            if (err?.response?.data?.error)
              dispatch(setError(err?.response?.data?.error));
            else if(err?.response?.data?.new_password){
              dispatch(setError(err?.response?.data?.new_password[0]));
            }else{
              dispatch(setError("Cannot change password!"))
            }
            console.error(err)
        }).finally(() => {
            dispatch(clearLoadingMessage())
        })
    
  };


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData && userData.username) {
      setFormValues(prevValues => ({
        ...prevValues,
        username: userData.username
      }));
    }
  }, []);  


  const handleChange = (e) => {
    const name = e.target.name;
    const val = e.target.value;
    setFormValues({
      ...formValues,
      [name]: val,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
    <Box sx={{ flexGrow: 1, position: "sticky", top: 0, zIndex: 1200}}>
        <AppBar position="relative">
          <Toolbar>
              <IconButton color="inherit" onClick={() => navigate(-1)}>
                <ArrowBack />
              </IconButton>
              <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1}}>
              
              <Typography
                variant="h6"
                style={{ flexGrow: 1, textAlign: 'center' }}
              >
                
                Update Password
              </Typography>  
            </Box>
            {/* <SelectSupplierDropdown hid={true}/> */}
            
            <IconButton disabled/>
            </Toolbar>
          </AppBar>
      </Box>

      <Grid container spacing={3} sx={{ textAlign: "center", mt: 5 }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 6 }}>
          <LogoIcon/>
          <div/>
          {APP_NAME}
          <div>
          Update Password
          </div>
        </Typography>
        
      </Grid>

        <Grid item xs={12} >
        {errorMessage && <Alert severity='error' sx={{mt:1}}>{errorMessage}</Alert>}
        </Grid>
      
      <Grid item xs={12}>
        <TextField
          disabled
          type="text"
          label="Username"
          name="username"
          required
          value={formValues.username}
          onChange={handleChange}
          variant="outlined"
          sx={{width:"300px"}}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          type={showPassword ? 'text': 'password'}
          label="Old Password"
          name="old_password"
          value={formValues.old_password}
          onChange={handleChange}
          variant="outlined"
          sx={{width:"300px"}}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={togglePasswordVisibility}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField

          type='password'
          label="New Password"
          name="new_password"
          value={formValues.new_password}
          onChange={handleChange}
          variant="outlined"
          sx={{width:"300px"}}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          
          type='password'
          label="Confirm Password"
          name="confirm_password"
          value={formValues.confirm_password}
          onChange={handleChange}
          variant="outlined"
          sx={{width:"300px"}}
          disabled={!formValues.new_password}
          error={formValues.new_password !== formValues.confirm_password}
          helperText={ formValues.new_password !== formValues.confirm_password ? "Password does not match":""}
        />
      </Grid>

      <Grid item xs={12}>
        <Button 
            disabled={!formValues.username || !formValues.old_password || !formValues.new_password || formValues.new_password !== formValues.confirm_password}
            variant="contained" 
            color="primary" 
            onClick={handleNextClick}>
          Update Password 
        </Button>
      </Grid>
    </Grid>
    </div>
  );
};

export default UserChangePassword;
